var theme = {
    breakpoints: {
        s: '640px',
        m: '1024px',
        l: '1440px',
    },
};
export default theme;
